import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'

import { Editor } from './Editor';
import { Dashboard } from './Dashboard';

import * as actionCreators from 'store/actions';

const Container = styled.div`
    width: 100%;
    height: 100%;
`

const IntegrationsModule = props => {
    const [screen, setScreen] = React.useState('DASHBOARD');
    const [workflow, setWorkflow] = React.useState(null);
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const uid = user['uid']
    
    React.useEffect(() => {
        dispatch(actionCreators.getWorkflows({ filters: { userId: uid } }))
        // dispatch(actionCreators.getClients({ filters: { userId: uid } }))
    }, [])

    let content;
    switch (screen) {
        case 'DASHBOARD':
            content = <Dashboard setScreen={setScreen} setWorkflow={setWorkflow}/>
            break
        case 'EDITOR':
            content = <Editor setScreen={setScreen} workflow={workflow}/>
            break
        default:
            content = <Dashboard setScreen={setScreen}/>
    }
    return (
        <Container>
            {content}
        </Container>
    )
}

export default IntegrationsModule